
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import TestimonialKeyword from "./TestimonialKeyword";
import RelatedServices from "../components/RelatedServices";
import FAQKeyword from './FAQKeyword';

function Tempotravellerhire() {



    const cardData =
    {
        keyword: 'Tempo Traveller Hire in Pune',
        heading: 'Amruta Travels: Tempo Traveller Hire in Pune',
        headingDescription: 'Looking for a reliable Tempo Traveller Hire in Pune? Amruta Travels offers premium Tempo Traveller rental services for family vacations, corporate travel, weddings, airport transfers, pilgrimage tours, school trips and outstation journeys. Choose from our well-maintained 9, 12, 13, 17 and 20 Seater Tempo Travellers with comfortable pushback seats, powerful air conditioning, spacious luggage space and experienced chauffeurs. Whether you are travelling to Lonavala, Mahabaleshwar, Shirdi, Mumbai, Goa or anywhere across Maharashtra, we provide safe, affordable and comfortable group transportation with transparent pricing and 24×7 booking support.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located around 120 km from Pune, Mahabaleshwar is a scenic hill station famous for its strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Wilson Point. It's an ideal spot for nature lovers and weekend getaways."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range are popular for their green valleys, monsoon waterfalls, and attractions like Bhushi Dam and Tiger’s Leap. Great for a quick escape from city life."
  },
  {
    "title": "Shirdi",
    "description": "About 190 km from Pune, Shirdi is a major pilgrimage town dedicated to Sai Baba. The Sai Baba Temple attracts millions of devotees annually. The spiritual atmosphere makes it perfect for religious tourism."
  },
  {
    "title": "Goa",
    "description": "Located nearly 450 km from Pune, Goa is the ultimate beach holiday destination. From vibrant nightlife and water sports to heritage forts and churches, Goa offers something for every traveler."
  },
  {
    "title": "Nashik",
    "description": "Around 210 km from Pune, Nashik is known for its religious significance and as India’s wine capital. Key attractions include the Kalaram Temple, Sula Vineyards, and Trimbakeshwar Temple."
  },
  {
    "title": "Alibaug",
    "description": "Situated 140 km away, Alibaug is a coastal town with serene beaches like Nagaon and historical forts such as Kolaba Fort. It’s a popular choice for beach lovers and family picnics."
  },
  {
    "title": "Kolhapur",
    "description": "Roughly 235 km from Pune, Kolhapur is home to the famous Mahalaxmi Temple and is known for its rich cultural heritage and spicy cuisine. It also offers attractions like Rankala Lake and Panhala Fort."
  },
  {
    "title": "Lavasa",
    "description": "Just 60 km from Pune, Lavasa is a planned city nestled in the Western Ghats, offering lakeside views, water sports, and a peaceful retreat. Perfect for a one-day outing or weekend stay."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "About 120 km from Pune, Satara is a gateway to the Kaas Plateau, a UNESCO-listed biodiversity hotspot. Visit during the monsoon to witness a stunning bloom of wildflowers across the valley."
  },
  {
    "title": "Aurangabad",
    "description": "Situated 235 km from Pune, Aurangabad is known for the Ajanta and Ellora Caves (UNESCO World Heritage Sites), Bibi Ka Maqbara, and Daulatabad Fort. A must-visit for history and architecture enthusiasts."
  }
],

    "services": [
{
    "name": "9 Seater Tempo Traveller Hire in Pune",
    "description": "Perfect for small families and groups, our 9 Seater Tempo Traveller offers comfortable seating, air conditioning and ample luggage space for local sightseeing, airport transfers and outstation trips."
},
{
    "name": "12 Seater Tempo Traveller Hire in Pune",
    "description": "One of our most popular vehicles for family vacations, corporate travel, weddings and weekend getaways. Spacious seating and professional drivers ensure a comfortable journey."
},
{
    "name": "13 Seater Tempo Traveller on Rent in Pune",
    "description": "Ideal for medium-sized groups travelling within Pune or to destinations like Lonavala, Mahabaleshwar, Shirdi, Mumbai and Goa."
},
{
    "name": "17 Seater Tempo Traveller Hire in Pune",
    "description": "Comfortable travel solution for corporate teams, wedding guests, educational tours, pilgrimage groups and outstation travel with premium seating and luggage space."
},
{
    "name": "20 Seater Tempo Traveller Rental",
    "description": "Designed for larger groups requiring comfortable transportation for tours, conferences, corporate outings and long-distance travel."
},
{
    "name": "Luxury Tempo Traveller Hire",
    "description": "Premium Tempo Travellers with pushback seats, LED TV, music system, charging points, spacious interiors and luxury travel experience."
},
{
    "name": "Tempo Traveller for Corporate Travel",
    "description": "Reliable transportation for conferences, exhibitions, employee outings, client visits, airport transfers and business meetings across Pune."
},
{
    "name": "Tempo Traveller for Wedding",
    "description": "Comfortable transportation for wedding guests, family members and destination wedding events with experienced chauffeurs."
},
{
    "name": "Tempo Traveller for Outstation Trips",
    "description": "Book Tempo Travellers for Shirdi, Lonavala, Mahabaleshwar, Goa, Mumbai, Nashik, Kolhapur, Alibaug and other destinations."
},
{
    "name": "Tempo Traveller Airport Transfer Pune",
    "description": "Professional airport pickup and drop services for families, tourists, business travellers and corporate groups."
},
{
    "name": "Tempo Traveller for Family Tour",
    "description": "Travel comfortably with your entire family using our spacious Tempo Travellers designed for vacations, pilgrimages and sightseeing."
},
{
    "name": "Tempo Traveller for School & College Trips",
    "description": "Safe and reliable transportation for educational institutions, industrial visits, excursions and study tours with experienced drivers."
}
],
  "tableData": [
["9 Seater Tempo Traveller Hire in Pune", "12 Seater Tempo Traveller Hire in Pune"],
["13 Seater Tempo Traveller Hire in Pune", "17 Seater Tempo Traveller Hire in Pune"],
["20 Seater Tempo Traveller Rental", "Luxury Tempo Traveller Hire"],
["Tempo Traveller for Corporate Travel", "Tempo Traveller for Wedding"],
["Tempo Traveller for Family Trip", "Tempo Traveller for Outstation Trips"],
["Tempo Traveller Airport Transfer Pune", "Tempo Traveller for School & College Trips"],
["Tempo Traveller for Shirdi", "Tempo Traveller for Lonavala"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Tempo Traveller Hire Services in Pune",
    "WhyChoosedescription": "Amruta Travels offers trusted and well-maintained Tempo Travellers for hire in Pune, ideal for group travel. Whether it's a family trip, corporate outing, pilgrimage, or outstation tour, our Tempo Travellers provide a comfortable and convenient travel solution for up to 17 passengers."
  },
  {
    "WhyChooseheading": "Perfect for Family Trips, Group Tours, and Events",
    "WhyChoosedescription": "Our Tempo Travellers are perfect for small to medium-sized groups traveling together. Whether you're attending a wedding, exploring weekend getaways, or heading out for a corporate team outing, our vehicles offer ample space and comfort for an enjoyable journey."
  },
  {
    "WhyChooseheading": "Multiple Seating Options to Suit Your Group Size",
    "WhyChoosedescription": "Choose from various seating capacities such as 9-seater, 12-seater, 15-seater, and 17-seater Tempo Travellers depending on your group size. All vehicles are equipped with spacious seating, pushback seats, and wide aisles for maximum passenger comfort."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Tempo Traveller Pricing",
    "WhyChoosedescription": "We offer competitive and transparent pricing for all Tempo Traveller rentals in Pune. Our all-inclusive packages cover fuel, tolls, driver charges, and taxes—so there are no hidden costs. Plan your trip confidently with clear and upfront rates."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicles with Modern Amenities",
    "WhyChoosedescription": "Our fleet of Tempo Travellers comes with air conditioning, comfortable pushback seats, music systems, USB charging ports, and ample luggage space. We ensure each vehicle is clean, serviced, and road-ready for your peace of mind."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers for a Smooth Ride",
    "WhyChoosedescription": "All our drivers are experienced, licensed, and trained to provide excellent customer service. They are well-versed in city and highway routes, ensuring a safe, punctual, and smooth journey whether you're traveling within Pune or to outstation destinations."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for All Types of Travel",
    "WhyChoosedescription": "Amruta Travels offers Tempo Traveller rentals for hourly, daily, or multi-day trips. Whether you need a vehicle for a day picnic, a weekend tour, or a long vacation, we provide flexible plans to match your travel requirements."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Easy Booking Process",
    "WhyChoosedescription": "Booking a Tempo Traveller in Pune is quick and easy with Amruta Travels. Our user-friendly online platform and responsive customer support team are available 24/7 to help with reservations, itinerary planning, or last-minute changes."
  }
]
























    }

const faqData = [
  {
    question: 'Can I hire a Tempo Traveller in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers Tempo Traveller hire services in Pune. It is a great option for group travel, family trips, corporate outings, and outstation tours.',
  },
  {
    question: 'What seating capacities are available for Tempo Travellers?',
    answer: 'We offer Tempo Travellers with multiple seating capacities, including 9-seater, 12-seater, 17-seater, and 20-seater options to suit your group size and comfort preferences.',
  },
  {
    question: 'Are drivers included with Tempo Traveller rentals?',
    answer: 'Yes, all our Tempo Traveller rentals include a trained, experienced, and courteous driver to ensure your journey is safe and pleasant.',
  },
  {
    question: 'Can I book a Tempo Traveller for outstation travel from Pune?',
    answer: 'Absolutely. Our Tempo Travellers are available for both local and outstation trips to destinations like Lonavala, Mahabaleshwar, Shirdi, Mumbai, Goa, and more.',
  },
  {
    question: 'How much does it cost to rent a Tempo Traveller in Pune?',
    answer: 'The cost depends on the seating capacity, travel distance, and duration. Rates typically start from ₹22 per km for smaller vehicles. Contact us with your travel details for an accurate quote.',
  },
  {
    question: 'Are the Tempo Travellers well-maintained and sanitized?',
    answer: 'Yes, all our Tempo Travellers are regularly maintained and fully sanitized before every trip. We ensure comfort, cleanliness, and safety for all passengers.',
  },
  {
    question: 'Can I book a Tempo Traveller online with Amruta Travels?',
    answer: 'Yes, you can easily book a Tempo Traveller online through our website or by calling our customer support. We provide quick booking assistance and reliable service.',
  },
  {
    question: 'Is the Tempo Traveller suitable for corporate and family trips?',
    answer: 'Yes, Tempo Travellers are ideal for corporate events, weekend getaways, pilgrimages, weddings, and family holidays. They provide ample space, comfort, and convenience for group travel.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ramesh Waghmare',
    role: 'Software Engineer, Pune',
    text: 'We hired a 12-seater Tempo Traveller for a weekend trip to Mahabaleshwar. The vehicle was clean and spacious, and the driver was very professional. Amruta Travels made our journey enjoyable!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja More',
    role: 'Event Planner',
    text: 'Amruta Travels provided a 17-seater Tempo Traveller for our wedding guests. It was punctual, well-maintained, and the service was top-notch. Highly recommend their travel services in Pune!',
    rating: 5,
  },
];















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Bus Hire For Wedding in Pune",
    link: "/bus-hire-for-wedding-pune",
    alt: "Bus Hire For Wedding in Pune",
},
        {
    place: "/images/keyword/2.jpg",
    text: "Buses For Corporate Events",
    link: "/bus-service-for-corporate-pune",
    alt: "Buses For Corporate Events",
},
        {
    place: "/images/keyword/3.jpg",
    text: "25 Seater Tempo Traveller on Rent in Pune",
    link: "/tempo-traveller-hire-in-pune",
    alt: "25 Seater Tempo Traveller on Rent in Pune",
},
        {
    place: "/images/keyword/4.jpg",
    text: "32 Seater Bus Rent in Pune",
    link: "/bus-hire-in-pune",
    alt: "32 Seater Bus Rent in Pune",

},
        {
    place: "/images/keyword/5.jpg",
    text: "35 Seater Bus on Rent in Pune",
    link: "/bus-hire-in-pune",
    alt: "35 Seater Bus on Rent in Pune",
},
        {
    place: "/images/keyword/6.jpg",
    text: "45 Seater Bus on Rent in Pune",
    link: "/bus-hire-in-pune",
    alt: "45 Seater Bus on Rent in Pune",
},
        {
    place: "/images/keyword/7.jpg",
    text: "50 Seater Bus on Rent in Pune",
    link: "/bus-hire-in-pune",
    alt: "50 Seater Bus on Rent in Pune",
},

        {
    place: "/images/keyword/8.jpg",
    text: "Pune to Shirdi Bus Hire",
    link: "/bus-hire-in-pune",
    alt: "Pune to Shirdi Bus Hire",
},
        {
    place: "/images/keyword/9.jpg",
text: "Bus Rentals For School Trips in Pune",
    link: "/bus-hire-in-pune",
    alt: "Bus Rentals For School Trips in Pune",
},
        {
    place: "/images/keyword/10.jpg",
    text: "Bus booking for wedding in Pune",
    link: "/bus-hire-in-pune",
    alt: "Bus booking for wedding in Pune",
},

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
            link: "/bus-hire-in-pune",
            alt: "Bus Booking for Marriage",

        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
            link: "/bus-hire-in-pune",
            alt: "Bus Service for Corporate Pune",

        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
            link: "/bus-hire-in-pune",
            alt: "Bus on Rent For Event in Pune",

        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
            link: "/bus-hire-in-pune",
            alt: "Bus Rental for Tour Packages",

        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
            link: "/bus-hire-in-pune",
            alt: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
            link: "/bus-hire-in-pune",
            alt: "AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
            link: "/bus-hire-in-pune",
            alt: "Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
            link: "/bus-hire-in-pune",
            alt: "Bus Service for Picnic in Pune ",

        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
            link: "/bus-hire-in-pune",
            alt: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
            link: "/bus-hire-in-pune",
            alt: "Luxury Bus Rental in Pune",

        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
            link: "/bus-hire-in-pune",
            alt: "Luxury Force Urbania On Rent in Pune ",

        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
            link: "/bus-hire-in-pune",
            alt: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",

        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
            link: "/bus-hire-in-pune",
            alt: "Pune to Alibaug Bus on Rent",

        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
            link: "/bus-hire-in-pune",
            alt: "Pune to Ganpatipule Beach Bus Rental Service ",

        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
            link: "/bus-hire-in-pune",
            alt: "Pune to 5 Jyotirlinga Darshan Bus Hire",

        },
    ];


    const images = [
{
    src: "/images/gallery/24.jpg",
    alt: "Tempo Traveller Hire in Pune",
    title: "Tempo Traveller Hire in Pune | Amruta Travels",
    caption: "Premium Tempo Traveller available for local and outstation trips."
},
{
    src: "/images/gallery/28.jpg",
    alt: "12 Seater Tempo Traveller on Rent in Pune",
    title: "12 Seater Tempo Traveller",
    caption: "Comfortable 12 Seater Tempo Traveller for family vacations and corporate travel."
},
{
    src: "/images/gallery/2.jpg",
    alt: "17 Seater Tempo Traveller Hire in Pune",
    title: "17 Seater Tempo Traveller",
    caption: "Spacious 17 Seater Tempo Traveller with pushback seats and luggage space."
},
{
    src: "/images/gallery/3.jpg",
    alt: "Luxury Tempo Traveller Pune",
    title: "Luxury Tempo Traveller Hire",
    caption: "Luxury Tempo Traveller for weddings, corporate travel and VIP transportation."
},
{
    src: "/images/gallery/24.jpg",
    alt: "Tempo Traveller for Wedding",
    title: "Wedding Tempo Traveller",
    caption: "Comfortable transportation for wedding guests and family members."
},
{
    src: "/images/gallery/27.jpg",
    alt: "Tempo Traveller for Outstation Trips",
    title: "Outstation Tempo Traveller",
    caption: "Book Tempo Traveller for Goa, Lonavala, Shirdi, Mahabaleshwar and Mumbai."
},
{
    src: "/images/gallery/29.jpg",
    alt: "Corporate Tempo Traveller Pune",
    title: "Corporate Tempo Traveller",
    caption: "Reliable transportation for conferences, meetings and corporate outings."
},
{
    src: "/images/gallery/30.jpg",
    alt: "Airport Transfer Tempo Traveller Pune",
    title: "Airport Transfer Tempo Traveller",
    caption: "Professional airport pickup and drop service for families and business travellers."
},
{
    src: "/images/gallery/31.jpg",
    alt: "Family Tempo Traveller Hire Pune",
    title: "Family Tempo Traveller Rental",
    caption: "Safe and comfortable Tempo Traveller for family holidays and group tours."
}
];






const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",

  "name": "Tempo Traveller Hire in Pune",

  "serviceType": "Tempo Traveller Rental",

  "url": "https://bushireinpune.com/tempo-traveller-hire-in-pune",

  "image": "https://bushireinpune.com/images/keyword/81.jpg",

  "description": "Rent a Tempo Traveller in Pune for family trips, corporate events, weddings, airport transfers and outstation travel with Amruta Travels.",

  "areaServed": {
      "@type": "City",
      "name": "Pune"
  },

  "provider": {
      "@type": "Organization",
      "name": "Amruta Travels",
      "url": "https://bushireinpune.com",
      "telephone": "+91 7353109555"
  },

  "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "3500",
      "availability": "https://schema.org/InStock",
      "url": "https://bushireinpune.com/tempo-traveller-hire-in-pune"
  }
}

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://bushireinpune.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Tempo Traveller Hire in Pune",
      "item": "https://bushireinpune.com/tempo-traveller-hire-in-pune"
    }
  ]
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  "@id": "https://bushireinpune.com/#business",
  "name": "Amruta Travels",
  "url": "https://bushireinpune.com/",
  "telephone": "+91 7353109555",
  "email": "booking@bushireinpune.com",
  "image": "https://bushireinpune.com/images/logo.jpg",
  "logo": "https://bushireinpune.com/images/logo.jpg",

  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office No.-2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Vadgaon Budruk",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411041",
    "addressCountry": "IN"
  },

  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.463",
    "longitude": "73.829"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};


    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Tempo Traveller Hire in Pune | 14 Seater, 17 Seater, 32 Seater</title>
  <meta 
    name="description" 
    content="Hire a tempo traveller in Pune for family trips, religious tours, and corporate events. Available in sizes 14-seater, 17-seater, and 32-seater for destinations like Shirdi, Mahabaleshwar, and Goa." 
  />
  <link
  rel="canonical"
  href="https://bushireinpune.com/tempo-traveller-hire-in-pune"
/>
  <script type="application/ld+json">
  {JSON.stringify(serviceSchema)}
</script>

<script type="application/ld+json">
  {JSON.stringify(breadcrumbSchema)}
</script>
<script type="application/ld+json">
{JSON.stringify(localBusinessSchema)}
</script>
<meta property="og:type" content="website" />
<meta
  property="og:title"
  content="Tempo Traveller Hire in Pune | Amruta Travels"
/>

<meta
  property="og:description"
  content="Hire Tempo Traveller in Pune for family trips, corporate travel, weddings and outstation tours."
/>

<meta
  property="og:url"
  content="https://bushireinpune.com/tempo-traveller-hire-in-pune"
/>

<meta
  property="og:image"
  content="https://bushireinpune.com/images/keyword/81.jpg"
/>
<meta name="twitter:card" content="summary_large_image" />

<meta
  name="twitter:title"
  content="Tempo Traveller Hire in Pune"
/>

<meta
  name="twitter:description"
  content="Book Tempo Traveller Hire in Pune with Amruta Travels."
/>

<meta
  name="twitter:image"
  content="https://bushireinpune.com/images/keyword/81.jpg"
/>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img
    src="/images/keyword/81.jpg"
    alt="Luxury Tempo Traveller Hire in Pune by Amruta Travels"
    title="Tempo Traveller Hire in Pune | Amruta Travels"
    loading="eager"
    className="img-fluid"
/>
                            <h1 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading}</h1><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />
<div className="mt-5">

<h2 className="darkcolorrr mb-4">
Why Choose a Tempo Traveller Instead of Multiple Cars?
</h2>

<p>
Travelling together is always more enjoyable than splitting your group into multiple cars. A Tempo Traveller keeps everyone together, reduces travel expenses, simplifies trip planning and provides a much more comfortable journey. Whether you are travelling with family, friends, colleagues or wedding guests, hiring a Tempo Traveller makes group travel safer, easier and more economical.
</p>

<div className="row mt-4">

<div className="col-md-6">

<ul>

<li>Everyone travels together</li>

<li>Lower fuel and toll expenses</li>

<li>Professional chauffeur included</li>

<li>Spacious luggage compartment</li>

<li>Comfortable pushback seats</li>

<li>Powerful air conditioning</li>

</ul>

</div>

<div className="col-md-6">

<ul>

<li>Perfect for long-distance journeys</li>

<li>Ideal for corporate and family trips</li>

<li>Safer than travelling in multiple vehicles</li>

<li>Easy pickup and drop coordination</li>

<li>Available for local & outstation travel</li>

<li>Affordable group transportation</li>

</ul>

</div>

</div>

</div>
<div className="mt-5">

<h2 className="darkcolorrr mb-4">
Perfect for Every Type of Group Travel
</h2>

<p>
Whether you are planning a short local journey or a long outstation trip, our Tempo Travellers are designed to provide a comfortable and hassle-free travel experience. With multiple seating options, experienced chauffeurs and well-maintained vehicles, Amruta Travels offers reliable transportation for every occasion.
</p>

<div className="row mt-4">

<div className="col-md-6">

<h4 className="darkcolorrr">
Family Vacations
</h4>

<p>
Travel together with your family to

<Link to="/pune-to-lonavala-bus-hire">Lonavala</Link>,

<Link to="/pune-to-mahabaleshwar-bus-hire">Mahabaleshwar</Link>,

<Link to="/pune-to-goa-bus-hire">Goa</Link>,

and many more destinations.
</p>

<h4 className="darkcolorrr mt-4">
Corporate Outings
</h4>

<p>
Comfortable transportation for team outings, conferences, client visits, exhibitions, offsite meetings and employee events across Pune.
</p>

<h4 className="darkcolorrr mt-4">
Wedding Transportation
</h4>

<p>
Convenient travel for wedding guests, relatives and family members with spacious seating and professional drivers.
</p>

</div>

<div className="col-md-6">

<h4 className="darkcolorrr">
Pilgrimage Tours
</h4>

<p>
Book Tempo Travellers for Shirdi, Ashtavinayak, Bhimashankar, Trimbakeshwar and other religious destinations with complete comfort.
</p>

<h4 className="darkcolorrr mt-4">
Airport Transfers
</h4>

<p>
Reliable airport pickup and drop services for families, tourists, corporate executives and business travellers in Pune.
</p>

<h4 className="darkcolorrr mt-4">
School & College Trips
</h4>

<p>
Safe transportation for educational tours, industrial visits, excursions and college trips with experienced drivers.
</p>

</div>

</div>

</div>
                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>

<section className="pt-5 pb-5">
  <div className="container">

    <h2>
      Tempo Traveller vs Bus Hire in Pune – Which One Should You Choose?
    </h2>

    <p>
      If your group has 9 to 20 passengers, hiring a Tempo Traveller in Pune is
      the most economical and comfortable choice. It offers better flexibility,
      lower rental costs, and easy travel through city roads.
    </p>

    <p>
      For larger groups of more than 25 passengers, Bus Hire in Pune is a better
      option. Luxury buses provide spacious seating, luggage space, air
      conditioning and are ideal for corporate outings, school trips, weddings,
      religious tours and long-distance travel.
    </p>

    <p>
      At Amruta Travels, we provide both Tempo Traveller Rental and Luxury Bus
      Hire services so that customers can choose the perfect vehicle according
      to their group size and travel requirements.
    </p>

  </div>
</section>
                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
<div className="container mt-4 mb-4">
  <p className="text-muted small">
    Last Updated: August 2026
  </p>
</div>

                            <RelatedServices page="tempo" />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <Link
    to={e.link}
    className="d-flex justify-content-around align-items-center"
>
                                            <div className="b1">
                                                <img
    src={e.place}
    alt={e.alt}
    loading="lazy"
    decoding="async"
/>
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <span className="px-3">
    {e.text}
</span>
                                            </div>
                                        </Link>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
    src={image.src}
    alt={image.alt}
    title={image.title}
    loading="lazy"
    className="gallery-image"
/>

<p className="text-center mt-2 small text-muted">
    {image.caption}
</p>
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Tempotravellerhire;